import React from 'react';
import BadgeCheck from "assets/icons/BadgeCheck";
import BadgeClock from "assets/icons/BadgeClock";
import BadgeClose from "assets/icons/BadgeClose";
import BadgeEdit from "assets/icons/BadgeEdit";
import {
    AVISO_SISTEMA,
    CONTRATO_STATUS_AGUARDANDO_ASSINATURA,
    CONTRATO_STATUS_AGUARDANDO_EXTRATO,
    CONTRATO_STATUS_APROVADO,
    CONTRATO_STATUS_DESATIVADO,
    CONTRATO_STATUS_EM_ANALISE,
    CONTRATO_STATUS_EM_EDICAO,
    CONTRATO_STATUS_ENCERRADO,
    CONTRATO_STATUS_NAO_INICIADO,
    CONTRATO_STATUS_NEGADO,
    CONTRATO_STATUS_VIGENTE,
    PESQUISA,
    INFORMACAO
} from "library/ContratoStatus";
import { StatusDetails, statusMapping } from "models/contratos";
import './index.scss'
import BadgeWarning from 'assets/icons/BadgeWarning';

type ContratoStatus =
    | typeof CONTRATO_STATUS_AGUARDANDO_ASSINATURA
    | typeof CONTRATO_STATUS_AGUARDANDO_EXTRATO
    | typeof CONTRATO_STATUS_APROVADO
    | typeof CONTRATO_STATUS_DESATIVADO
    | typeof CONTRATO_STATUS_EM_ANALISE
    | typeof CONTRATO_STATUS_EM_EDICAO
    | typeof CONTRATO_STATUS_ENCERRADO
    | typeof CONTRATO_STATUS_NAO_INICIADO
    | typeof CONTRATO_STATUS_NEGADO
    | typeof CONTRATO_STATUS_VIGENTE
    | typeof AVISO_SISTEMA
    | typeof PESQUISA
    | typeof INFORMACAO

type StatusIconsType = {
    [key in ContratoStatus]: JSX.Element;
};

export const statusIcons: StatusIconsType = {
    [CONTRATO_STATUS_APROVADO]: <BadgeCheck className='badgeIcon' color='#146E37' />,
    [CONTRATO_STATUS_VIGENTE]: <BadgeCheck className='badgeIcon' color='#146E37' />,
    [CONTRATO_STATUS_ENCERRADO]: <BadgeClose className='badgeIcon' color='#730028' />,
    [CONTRATO_STATUS_NAO_INICIADO]: <BadgeClock className='badgeIcon' color='#323C32' />,
    [CONTRATO_STATUS_NEGADO]: <BadgeClose className='badgeIcon' color='#730028' />,
    [CONTRATO_STATUS_DESATIVADO]: <BadgeClose className='badgeIcon' color='#323C32' />,
    [CONTRATO_STATUS_EM_EDICAO]: <BadgeEdit className='badgeIcon' color='#5A3C1E' />,
    [CONTRATO_STATUS_EM_ANALISE]: <BadgeClock className='badgeIcon' color='#323C32' />,
    [CONTRATO_STATUS_AGUARDANDO_ASSINATURA]: <BadgeClock className='badgeIcon' color='#323C32' />,
    [CONTRATO_STATUS_AGUARDANDO_EXTRATO]: <BadgeClock className='badgeIcon' color='#323C32' />,
    [AVISO_SISTEMA]: <BadgeWarning className='badgeIcon' color='#5A3C1E' />,
    [PESQUISA]: <BadgeClock className='badgeIcon' color='#323C32' />,
    [INFORMACAO]: <BadgeWarning className='badgeIcon' color='#323C32'/>
};

interface BadgeProps {
    status: number;
}

const getStatusBadgeClass = (status: ContratoStatus) => {
    switch (status) {
        case CONTRATO_STATUS_NEGADO:
            return 'badge-danger';
        case CONTRATO_STATUS_APROVADO:
            return 'badge-success';
        case CONTRATO_STATUS_EM_EDICAO:
            return 'badge-warning';
        case CONTRATO_STATUS_EM_ANALISE:
            return 'badge-info';
        case CONTRATO_STATUS_AGUARDANDO_ASSINATURA:
            return 'badge-info';
        case CONTRATO_STATUS_AGUARDANDO_EXTRATO:
            return 'badge-info';
        case CONTRATO_STATUS_NAO_INICIADO:
            return 'badge-info';
        case CONTRATO_STATUS_VIGENTE:
            return 'badge-success';
        case CONTRATO_STATUS_ENCERRADO:
            return 'badge-danger';
        case CONTRATO_STATUS_DESATIVADO:
            return 'badge-disabled';
        case PESQUISA:
            return 'badge-info';
        case AVISO_SISTEMA:
            return 'badge-warning';
        case INFORMACAO:
            return 'badge-warning';
    }
};

export const Badge: React.FC<BadgeProps> = ({ status }) => {
    const contratoStatus = statusMapping[status] as ContratoStatus;
    const statusDetail = StatusDetails[contratoStatus];
    const icon = statusIcons[contratoStatus];
    const badgeClass = getStatusBadgeClass(contratoStatus);

    if (!statusDetail) {
        return null;
    }

    return (
        <div className={`badge ${badgeClass} newCustomBadge`}>
            {icon}
            <span style={{ marginLeft: '5px' }}>
                {statusDetail.label}
            </span>
        </div>
    );
};

